import { Columns } from 'components/shared/Columns';
import { Page } from 'components/shared/Page';
import { Section } from 'components/shared/Section';

const approvedTypefaces = [
    <Columns
        key="1"
        columns={Columns.ColumnNumber.TWO}
        content={
            <>
                <div>
                    <h3>Libre Franklin</h3>
                    <p className="margin__bottom--x-small">
                        Libre Franklin is to be used for all organization print and web materials
                        including Free Market Health applications, general presentations, user
                        guides, etc. Libre Franklin can be downloaded from the downloads section.
                    </p>
                    <p className="sds_text__specimen__h1 margin__bottom--xx-small">
                        Aa Bb Cc Dd Ee Ff Gg Hh Ii Jj Kk Ll Mm Nn Oo Pp Qq Rr Ss Tt Uu Vv Ww Xx Yy
                        Zz
                    </p>
                    <p className="sds_text__specimen__h1 margin__bottom--xx-small">0123456789</p>
                    <p>Regular: Never let the process fail the patient</p>
                    <p className="sds_text__specimen__italic">
                        Italic: Never let the process fail the patient
                    </p>
                    <p className="sds_text__specimen__bold">
                        Bold: Never let the process fail the patient
                    </p>
                    <p className="sds_text__specimen__bold-italic">
                        Bold Italic: Never let the process fail the patient
                    </p>
                </div>
                <div>
                    <h3 className="sds_text__specimen__halcom-bold">Halcom</h3>
                    <p className="sds_text__specimen__halcom-regular margin__bottom--x-small">
                        Halcom is to be used for all marketing print and web materials including the
                        Free Market Health website. If you need Halcom please contact the marketing
                        or design team.
                    </p>
                    <p className="sds_text__specimen__h1 margin__bottom--xx-small sds_text__specimen__halcom-bold">
                        Aa Bb Cc Dd Ee Ff Gg Hh Ii Jj Kk Ll Mm Nn Oo Pp Qq Rr Ss Tt Uu Vv Ww Xx Yy
                        Zz
                    </p>
                    <p className="sds_text__specimen__h1 margin__bottom--xx-small sds_text__specimen__halcom-bold">
                        0123456789
                    </p>
                    <p className="sds_text__specimen__halcom-regular">
                        Regular: Never let the process fail the patient
                    </p>
                    <p className="sds_text__specimen__halcom-italic">
                        Italic: Never let the process fail the patient
                    </p>
                    <p className="sds_text__specimen__halcom-bold">
                        Bold: Never let the process fail the patient
                    </p>
                    <p className="sds_text__specimen__halcom-bold-italic">
                        Bold Italic: Never let the process fail the patient
                    </p>
                </div>
            </>
        }
    />,
];

const typeSpecimen = [
    <p key="2">
        Use the type specimen as a starting point to document design and typographic hierarchy.
        Frequently design restrictions will require deviating from this pattern.
    </p>,
    <div key="3" className="sds_text__specimen__container">
        <div className="sds_text__specimen__column-one">
            <div className="margin__top--x-small">H1</div>
            <div>Bold 36/42</div>
        </div>
        <div className="sds_text__specimen__column-two sds_text__specimen__h1">
            Enhancing the specialty pharmacy system for the benefit of pharmacies, payers and
            patients.
        </div>
    </div>,
    <div key="4" className="sds_text__specimen__container">
        <div className="sds_text__specimen__column-one">
            <div className="margin__top--x-small">H2</div>
            <div>Bold All Caps 24/30</div>
        </div>
        <div className="sds_text__specimen__column-two sds_text__specimen__h2">
            Enhancing the specialty pharmacy system for the benefit of pharmacies, payers and
            patients.
        </div>
    </div>,
    <div key="5" className="sds_text__specimen__container">
        <div className="sds_text__specimen__column-one">
            <div>H3</div>
            <div>Bold 16/24</div>
        </div>
        <div className="sds_text__specimen__column-two sds_text__specimen__h3">
            Enhancing the specialty pharmacy system for the benefit of pharmacies, payers and
            patients.
        </div>
    </div>,
    <div key="6" className="sds_text__specimen__container">
        <div className="sds_text__specimen__column-one">
            <div>P</div>
            <div>Regular 16/24</div>
        </div>
        <div className="sds_text__specimen__column-two sds_text__specimen__p">
            Free Market Health has created a care-driven marketplace platform that improves the
            specialty pharmacy ecosystem. Right now, patients can wait days or even weeks to receive
            medications, and resources are wasted along the way. What we do is seamlessly facilitate
            a match between patients and the specialty pharmacy best suited for their care needs,
            give payers more control of their spending, and enable value-based care. The care-driven
            marketplace empowers specialty pharmacies and payers by creating a better-orchestrated
            process with enhanced visibility and flexibility—and most importantly, it enables better
            patient outcomes.
        </div>
    </div>,
    <div key="7" className="sds_text__specimen__container">
        <div className="sds_text__specimen__column-one">
            <div>Hero</div>
            <div>Regular 24/30</div>
        </div>
        <div className="sds_text__specimen__column-two sds_text__specimen__hero">
            Enhancing the specialty pharmacy system for the benefit of pharmacies, payers and
            patients.
        </div>
    </div>,
    <div key="8" className="sds_text__specimen__container">
        <div className="sds_text__specimen__column-one">
            <div>Caption</div>
            <div>Regular 14/20</div>
        </div>
        <div className="sds_text__specimen__column-two sds_text__specimen__caption">
            Enhancing the specialty pharmacy system for the benefit of pharmacies, payers and
            patients.
        </div>
    </div>,
    <div key="9" className="sds_text__specimen__container">
        <div className="sds_text__specimen__column-one">
            <div>Call To Action</div>
            <div>Boxed Semi-Bold All Caps 14/14</div>
        </div>
        <div className="sds_text__specimen__call-to-action">Get Started</div>
    </div>,
];

export const Typography = () => (
    <div>
        <Page
            pageTitle="Typography"
            pageDescription="Typography is another essential element of the Free Market Health identity. Consistent use of the prescribed typeface throughout brand communications will help maintain a cohesive visual style."
            pageContent={
                <>
                    <Section title="Approved Typefaces" contentArray={approvedTypefaces} />
                    <Section title="Type Specimen" contentArray={typeSpecimen} />
                </>
            }
        />
    </div>
);
